import { useEffect, useState } from "react";

// Chart.js paints on a canvas and cannot read CSS variables, so resolve the
// theme's text color from a themed element and re-resolve when the app flips
// data-theme on <html>.
function hexToRgba(hex, alpha) {
  const m = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.exec((hex || "").trim());
  if (!m) return `rgba(128,128,128,${alpha})`;
  let h = m[1];
  if (h.length === 3) h = h.split("").map((c) => c + c).join("");
  const n = parseInt(h, 16);
  return `rgba(${(n >> 16) & 255},${(n >> 8) & 255},${n & 255},${alpha})`;
}

export function useChartTheme(ref) {
  const [colors, setColors] = useState({ text: "#666", grid: "rgba(128,128,128,0.2)" });
  useEffect(() => {
    const read = () => {
      const el = ref?.current || document.documentElement;
      const text = getComputedStyle(el).getPropertyValue("--gpt-seo-text-secondary").trim() || "#666";
      setColors({ text, grid: hexToRgba(text, 0.2) });
    };
    read();
    const obs = new MutationObserver(read);
    obs.observe(document.documentElement, { attributes: true, attributeFilter: ["data-theme"] });
    return () => obs.disconnect();
  }, [ref]);
  return colors;
}

// Shared options for "rate over runs" line charts: 0–100 % axis, themed ticks.
export function rateChartOptions(colors) {
  return {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: { ticks: { color: colors.text }, grid: { color: colors.grid } },
      y: {
        min: 0, max: 100,
        ticks: { color: colors.text, callback: (v) => `${v}%` },
        grid: { color: colors.grid },
      },
    },
    plugins: {
      legend: { position: "bottom", labels: { color: colors.text } },
      tooltip: { callbacks: { label: (ctx) => `${ctx.dataset.label}: ${Math.round(ctx.parsed.y || 0)}%` } },
    },
  };
}

export const SERIES_COLORS = [
  "#2563eb", "#10b981", "#f59e0b", "#8b5cf6", "#ef4444", "#06b6d4", "#ec4899", "#84cc16",
];
